import { RouteModel } from "src/models/RouteModel";

import TwoFactorAuthPage from "./2fa/TwoFactorAuthPage";
import ForgotPasswordPage from "./forgotPassword/ForgotPasswordPage";
import { LoginPage } from "./login/LoginPage";
import { SignUpPage } from "./sign-up/SignUpPage";
import WelcomePage from "./welcome/WelcomePage";

/*
 * Routes for the authentication pages.
 * These routes are not displayed in the header.
 * and the header is hidden for these pages.
 */
export const authRoutes: RouteModel[] = [
  {
    title: "Login",
    path: "login/",
    element: <LoginPage />,
  },
  {
    title: "Join Us",
    path: "join-us",
    element: <SignUpPage />,
  },
  {
    title: "Two-Factor Authentication",
    path: "verify/",
    element: <TwoFactorAuthPage />,
  },
  {
    title: "Forgot Password",
    path: "forgot-password/",
    element: <ForgotPasswordPage />,
  },
  {
    title: "Set New Password",
    path: "reset-password/",
    element: <WelcomePage isSetNewPasswordPage={true} />,
  },
  {
    title: "Welcome",
    path: "welcome/",
    element: <WelcomePage isSetNewPasswordPage={false} />,
  },
].map((route) => ({ ...route, hideInHeader: true, hideHeader: true }));
